import { AUDIO_FILE_EXTENSIONS, IMAGE_FILE_EXTENSIONS, VIDEO_FILE_EXTENSIONS } from './file.types';
import axios from 'axios';

export const blobToFile = (blob: Blob, fileName: string) => {
  return new File([blob], fileName, {
    type: blob.type,
  });
};

export const downloadURI = (uri: string, fileName: string) => {
  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/*
 * Why we need this function
 *
 * Because Chrome have a bug when get recorded audio file, duration is infinity
 *
 * */
export const fixMediaDurationInfinity = (media) => {
  // Check if duration null
  const isValidDuration = (updatedMedia) => {
    return !(
      updatedMedia.duration === Infinity ||
      isNaN(updatedMedia.duration) ||
      updatedMedia.duration === undefined
    );
  };

  return new Promise((resolve) => {
    // Wait for media to load metadata
    media.onloadedmetadata = () => {
      // Changes the current time to update ontimeupdate
      media.currentTime = Number.MAX_SAFE_INTEGER;

      // Check if media infinite NaN or undefined
      if (!isValidDuration(media)) {
        media.ontimeupdate = () => {
          // If it is not null resolve the promise and send the duration
          if (isValidDuration(media)) {
            // If it is not null resolve the promise and send the duration
            resolve(media.duration);
          }
          // Check if its infinite NaN or undefined //The second ontime update is a fallback if the first one fails
          media.ontimeupdate = () => {
            if (isValidDuration(media)) {
              resolve(media.duration);
            }
          };
        };
      } else {
        // If media duration was never infinity return it
        resolve(media.duration);
      }
    };
  });
};

export const getAudioFileDurationFromUrl = async (url) => {
  const audioEl = document.createElement('audio');
  const sourceEl = document.createElement('source');
  sourceEl.type = 'audio/mpeg';
  sourceEl.src = url;
  audioEl.appendChild(sourceEl);
  const duration = await fixMediaDurationInfinity(audioEl);

  // Reset audio current time
  audioEl.currentTime = 0;

  return duration as number;
};

export const getVideoFileDurationFromUrl = async (url) => {
  const videoEl = document.createElement('video');
  videoEl.src = url;
  const duration = await fixMediaDurationInfinity(videoEl);

  // Reset video current time
  videoEl.currentTime = 0;

  return duration as number;
};

export const getFileExtensionFromName = (fileName: string) => {
  if (fileName) {
    const index = fileName?.lastIndexOf('.');
    return fileName?.substring(index);
  }
  return null;
};

export const isVideo = (file: File) =>
  file?.type.includes('video') ||
  VIDEO_FILE_EXTENSIONS.includes(getFileExtensionFromName(file?.name));

export const isAudio = (file: File) =>
  file?.type.includes('audio') ||
  AUDIO_FILE_EXTENSIONS.includes(getFileExtensionFromName(file?.name));

export const isImage = (file: File) =>
  file?.type.includes('image') ||
  IMAGE_FILE_EXTENSIONS.includes(getFileExtensionFromName(file?.name));

export const getFileType = (file: File) => {
  if (isVideo(file)) {
    return 'VIDEO';
  }
  if (isAudio(file)) {
    return 'AUDIO';
  }
  if (isImage(file)) {
    return 'IMAGE';
  }
};

export const downloadJSONAsExcelFile = async (jsondata: any[], fileName: string) => {
  const file = await axios.post(
    'https://apigateway.dolenglish.vn/n8n/webhook/export-excel-from-json',
    jsondata,
    {
      responseType: 'blob',
    }
  );
  const objectUrl = window.URL.createObjectURL(file.data);
  downloadURI(objectUrl, fileName);
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const downloadPdf = async (pdfURL, filename = 'document.pdf') => {
  try {
    const response = await fetch(pdfURL);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading PDF:', error);
  }
};
